<v-card flat class="form-ordine">
    <!-- Header compatto con numero commessa e azioni principali -->
    <v-card-title class="form-header pa-4 pb-2">
        <v-row class="ma-0 pa-0">
            <span class="text-h6 font-weight-bold text-truncate">Ordine</span>
            <v-spacer />
            <!-- Indicatore salvataggio automatico -->
            <transition name="fade-autosave">
                <span v-if="autoSalvatoIn" class="text-caption me-3 d-flex align-center" :class="{
                'text-medium-emphasis': autoSalvatoIn === 'saving',
                'text-success': autoSalvatoIn === 'saved',
                'text-error': autoSalvatoIn === 'error'}">
                    <v-progress-circular v-if="autoSalvatoIn === 'saving'" indeterminate size="12" width="2"
                        class="me-1" />
                    <v-icon v-else-if="autoSalvatoIn === 'saved'" size="14"
                        class="me-1">mdi-check-circle-outline</v-icon>
                    <v-icon v-else-if="autoSalvatoIn === 'error'" size="14"
                        class="me-1">mdi-alert-circle-outline</v-icon>
                    {{ autoSalvatoIn === 'saving' ? 'Salvataggio...' :
                    autoSalvatoIn === 'saved' ? 'Salvato' : 'Errore salvataggio' }}
                </span>
            </transition>
        </v-row>
        <v-btn color="primary" size="small" :loading="loading" @click="salva" prepend-icon="mdi-content-save">
            Salva
        </v-btn>
    </v-card-title>

    <v-card-text class="pa-3 pt-0">
        <v-form ref="formRef">

            <!-- ─── SEZIONE: Dati Generali ─── -->
            <v-expansion-panels v-model="panelAperti" variant="accordion" flat multiple>
                <v-expansion-panel eager>
                    <v-expansion-panel-title class="section-title px-3 py-2" :expand-icon-class="'ms-auto'">
                        <template #default="{ isExpanded }">
                            <v-icon :class="isExpanded ? 'text-primary' : 'text-medium-emphasis'" size="18"
                                class="me-2">
                                mdi-clipboard-text-outline
                            </v-icon>
                            <span class="text-body-2 font-weight-semibold">Dati Generali</span>
                            <!-- Indicatore campi obbligatori non compilati -->
                            <v-chip v-if="!datiInterni.data" color="error" size="x-small" class="ms-2"
                                variant="tonal">Incompleto</v-chip>
                        </template>
                    </v-expansion-panel-title>

                    <v-expansion-panel-text>
                        <v-row dense class="mt-1">
                            <v-col cols="12" sm="3">
                                <v-text-field v-model="datiInterni.numeroCommessa" label="N. Commessa"
                                    hide-details="auto" density="compact" variant="outlined" readonly>
                                    <template #prepend-inner>
                                        <v-icon size="16" class="text-medium-emphasis">mdi-pound</v-icon>
                                    </template>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-select v-model="datiInterni.tipoCommessa" :items="opzioni.tipi" label="Tipo commessa"
                                    item-value="value" item-title="label" hide-details="auto" density="compact"
                                    variant="outlined" />
                            </v-col>

                            <v-col cols="12" sm="3">
                                <v-text-field v-model="datiInterni.data" label="Data" type="date"
                                    :rules="[rules.required]" hide-details="auto" density="compact" variant="outlined">
                                    <template #prepend-inner>
                                        <v-icon size="16"
                                            class="text-medium-emphasis">mdi-calendar-today-outline</v-icon>
                                    </template>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field v-model="datiInterni.dataConsegna" label="Data Consegna" type="date"
                                    hide-details density="compact" variant="outlined">
                                    <template #prepend-inner>
                                        <v-icon size="16"
                                            class="text-medium-emphasis">mdi-calendar-check-outline</v-icon>
                                    </template>
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense class="mt-1">
                            <v-col cols="12" sm="12">
                                <v-textarea v-model="datiInterni.campoMisure" label="Misure" hide-details="auto"
                                    density="compact" variant="outlined" :rows="2" autoGrow :max-rows="4" />
                            </v-col>
                        </v-row>
                    </v-expansion-panel-text>
                </v-expansion-panel>

                <!-- ─── SEZIONE: Cliente ─── -->
                <v-expansion-panel eager>
                    <v-expansion-panel-title class="section-title px-3 py-2">
                        <template #default="{ isExpanded }">
                            <v-icon :class="isExpanded ? 'text-primary' : 'text-medium-emphasis'" size="18"
                                class="me-2">
                                mdi-account-outline
                            </v-icon>
                            <span class="text-body-2 font-weight-semibold">Cliente</span>
                            <v-chip v-if="!datiInterni.cognomeCliente" color="error" size="x-small" class="ms-2"
                                variant="tonal">Incompleto</v-chip>
                        </template>
                    </v-expansion-panel-title>

                    <v-expansion-panel-text>
                        <v-row dense class="mt-1">
                            <v-col cols="12" sm="6">
                                <v-text-field ref="rsField" v-model="datiInterni.ragioneSociale" label="Ragione sociale"
                                    :rules="[rules.personaGiuridicaOFisica_RS]" hide-details="auto" density="compact"
                                    variant="outlined" />
                            </v-col>

                            <v-col cols="12" sm="3">
                                <v-text-field ref="cognomeField" v-model="datiInterni.cognomeCliente" label="Cognome"
                                    :rules="[rules.personaGiuridicaOFisica_COG]" hide-details="auto" density="compact"
                                    variant="outlined" />
                            </v-col>

                            <v-col cols="12" sm="3">
                                <v-text-field ref="nomeField" v-model="datiInterni.nomeCliente" label="Nome"
                                    :rules="[rules.personaGiuridicaOFisica_NOME]" hide-details="auto" density="compact"
                                    variant="outlined" />
                            </v-col>

                            <v-col cols="12" sm="6">
                                <v-text-field v-model="datiInterni.viaCliente" label="Indirizzo" hide-details
                                    density="compact" variant="outlined">
                                    <template #prepend-inner>
                                        <v-icon size="16" class="text-medium-emphasis">mdi-map-marker-outline</v-icon>
                                    </template>
                                </v-text-field>
                            </v-col>
                            <v-col cols="7" sm="3">
                                <v-text-field v-model="datiInterni.cittaCliente" label="Città" hide-details
                                    density="compact" variant="outlined" />
                            </v-col>
                            <v-col cols="5" sm="3">
                                <v-text-field v-model="datiInterni.capCliente" label="CAP" hide-details
                                    density="compact" variant="outlined" maxlength="5" />
                            </v-col>

                            <v-col cols="12" sm="4">
                                <v-text-field v-model="datiInterni.emailCliente" label="E-mail" type="email"
                                    hide-details density="compact" variant="outlined">
                                    <template #prepend-inner>
                                        <v-icon size="16" class="text-medium-emphasis">mdi-email-outline</v-icon>
                                    </template>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field v-model="datiInterni.telefonoCliente" label="Telefono" hide-details
                                    density="compact" variant="outlined">
                                    <template #prepend-inner>
                                        <v-icon size="16" class="text-medium-emphasis">mdi-phone-outline</v-icon>
                                    </template>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field v-model="datiInterni.piCfCliente" label="P.I. / C.F." hide-details
                                    density="compact" variant="outlined">
                                    <template #prepend-inner>
                                        <v-icon size="16" class="text-medium-emphasis">mdi-card-text-outline</v-icon>
                                    </template>
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-expansion-panel-text>
                </v-expansion-panel>

                <!-- ─── SEZIONE: Cantiere ─── -->
                <v-expansion-panel eager>
                    <v-expansion-panel-title class="section-title px-3 py-2">
                        <template #default="{ isExpanded }">
                            <v-icon :class="isExpanded ? 'text-primary' : 'text-medium-emphasis'" size="18"
                                class="me-2">
                                mdi-office-building-cog-outline
                            </v-icon>
                            <span class="text-body-2 font-weight-semibold">Cantiere</span>
                        </template>
                    </v-expansion-panel-title>

                    <v-expansion-panel-text>
                        <v-row dense class="mt-1">
                            <v-col cols="12" sm="4">
                                <v-text-field v-model="datiInterni.intestazioneCantiere" label="Intestazione"
                                    hide-details density="compact" variant="outlined" />
                            </v-col>
                            <v-col cols="12" sm="5">
                                <v-text-field v-model="datiInterni.viaCantiere" label="Via" hide-details
                                    density="compact" variant="outlined">
                                    <template #prepend-inner>
                                        <v-icon size="16" class="text-medium-emphasis">mdi-map-marker-outline</v-icon>
                                    </template>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field v-model="datiInterni.cittaCantiere" label="Città" hide-details
                                    density="compact" variant="outlined" />
                            </v-col>
                        </v-row>
                    </v-expansion-panel-text>
                </v-expansion-panel>

                <!-- ─── SEZIONE: Specifiche Tecniche ─── -->
                <v-expansion-panel eager>
                    <v-expansion-panel-title class="section-title px-3 py-2">
                        <template #default="{ isExpanded }">
                            <v-icon :class="isExpanded ? 'text-primary' : 'text-medium-emphasis'" size="18"
                                class="me-2">
                                mdi-cog-outline
                            </v-icon>
                            <span class="text-body-2 font-weight-semibold">Specifiche Tecniche</span>
                        </template>
                    </v-expansion-panel-title>

                    <v-expansion-panel-text>
                        <!-- Fila selects principali -->
                        <v-row dense class="mt-1">
                            <v-col cols="12" sm="6" md="3">
                                <v-select v-model="datiInterni.essenza" :items="opzioni.essenze" item-value="value"
                                    item-title="label" label="Essenza" hide-details density="compact"
                                    variant="outlined" />
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field v-model="datiInterni.descrizioneEssenza" label="Descrizione essenza"
                                    hide-details density="compact" variant="outlined" />
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-select v-model="datiInterni.serie" :items="opzioni.serie" item-value="value"
                                    item-title="label" label="Serie" hide-details density="compact"
                                    variant="outlined" />
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-select v-model="datiInterni.profilo" :items="opzioni.profili" item-value="value"
                                    item-title="label" label="Profilo" hide-details density="compact"
                                    variant="outlined" />
                            </v-col>
                        </v-row>

                        <!-- Verniciatura con menu dropdown -->
                        <v-row dense>
                            <v-col cols="12" sm="6" md="3">
                                <v-select v-model="datiInterni.spessore" :items="opzioni.spessori" item-value="value"
                                    item-title="label" label="Spessore" hide-details density="compact"
                                    variant="outlined" />
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field v-model="datiInterni.verniciatura" label="Verniciatura" density="compact"
                                    variant="outlined" hide-details />
                            </v-col>

                            <v-col cols="12" sm="3" md="3">
                                <v-menu>
                                    <template #activator="{ props }">
                                        <v-btn v-bind="props" block variant="outlined" prepend-icon="mdi-menu-down">
                                            Scegli da elenco
                                        </v-btn>
                                    </template>

                                    <v-list>
                                        <v-list-item v-for="item in opzioni.verniciature" :key="item.value"
                                            @click="datiInterni.verniciatura = item.value">
                                            <v-list-item-title>{{ item.label }}</v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </v-col>
                        </v-row>

                        <!-- Campi bicolore -->
                        <v-row dense v-if="datiInterni.verniciatura.toLowerCase() === 'bicolore'">
                            <v-col cols="12" sm="6">
                                <v-text-field v-model="datiInterni.bicoloreInt" label="Colore Interno" density="compact"
                                    variant="outlined" hide-details>
                                    <template #prepend-inner>
                                        <v-icon size="16">mdi-square-half-full</v-icon>
                                    </template>
                                </v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6">
                                <v-text-field v-model="datiInterni.bicoloreEst" label="Colore Esterno" density="compact"
                                    variant="outlined" hide-details>
                                    <template #prepend-inner>
                                        <v-icon size="16">mdi-square-half-full</v-icon>
                                    </template>
                                </v-text-field>
                            </v-col>
                        </v-row>

                    </v-expansion-panel-text>
                </v-expansion-panel>

                <!-- ─── SEZIONE: Persiane & Avvolgibili ─── -->
                <v-expansion-panel eager>
                    <v-expansion-panel-title class="section-title px-3 py-2">
                        <template #default="{ isExpanded }">
                            <v-icon :class="isExpanded ? 'text-primary' : 'text-medium-emphasis'" size="18"
                                class="me-2">
                                mdi-window-shutter
                            </v-icon>
                            <span class="text-body-2 font-weight-semibold">Persiane & Avvolgibili</span>
                        </template>
                    </v-expansion-panel-title>

                    <v-expansion-panel-text>
                        <!-- Persiana -->
                        <v-row dense class="mt-1">
                            <v-col cols="12" sm="3">
                                <v-select v-model="datiInterni.persiana" :items="opzioni.persiane" item-value="value"
                                    item-title="label" label="Tipo Persiana" hide-details density="compact"
                                    variant="outlined" />
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field v-model="datiInterni.persianaDettagli" label="Dettagli" hide-details
                                    density="compact" variant="outlined" />
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-select v-model="datiInterni.verniciaturaPersiana" :items="opzioni.verniciature"
                                    item-value="value" item-title="label" label="Verniciatura" hide-details
                                    density="compact" variant="outlined" />
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field v-model="datiInterni.campionePersiana" label="Campione" hide-details
                                    density="compact" variant="outlined" />
                            </v-col>
                        </v-row>

                        <!-- Divider leggero -->
                        <v-divider class="my-3" />

                        <!-- Avvolgibili -->
                        <v-row dense>
                            <v-col cols="12" sm="3">
                                <v-select v-model="datiInterni.avvolgibili" :items="opzioni.avvolgibili"
                                    item-value="value" item-title="label" label="Avvolgibili" hide-details
                                    density="compact" variant="outlined" />
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field v-model="datiInterni.coloreAvvolgibili" label="Colore" hide-details
                                    density="compact" variant="outlined" />
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field v-model="datiInterni.accessori" label="Accessori" hide-details
                                    density="compact" variant="outlined" />
                            </v-col>
                            <v-col cols="12" sm="3" class="d-flex align-center">
                                <v-checkbox v-model="datiInterni.motore" label="Motore" hide-details density="compact"
                                    color="primary" class="mt-0" />
                            </v-col>
                        </v-row>
                    </v-expansion-panel-text>
                </v-expansion-panel>

                <!-- ─── SEZIONE: Antone, Zanzariera & Accessori ─── -->
                <v-expansion-panel eager>
                    <v-expansion-panel-title class="section-title px-3 py-2">
                        <template #default="{ isExpanded }">
                            <v-icon :class="isExpanded ? 'text-primary' : 'text-medium-emphasis'" size="18"
                                class="me-2">
                                mdi-door-open
                            </v-icon>
                            <span class="text-body-2 font-weight-semibold">Antone, Zanzariera & Accessori</span>
                        </template>
                    </v-expansion-panel-title>

                    <v-expansion-panel-text>
                        <!-- Antone + scuro -->
                        <v-row dense class="mt-1">
                            <v-col cols="12" sm="4">
                                <v-select v-model="datiInterni.antone" :items="opzioni.antoine" item-value="value"
                                    item-title="label" label="Antone" hide-details density="compact"
                                    variant="outlined" />
                            </v-col>
                            <v-col cols="12" sm="2" class="d-flex align-center">
                                <v-checkbox v-model="datiInterni.scuroInterno" label="Scuro Interno" hide-details
                                    density="compact" color="primary" class="mt-0" />
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-select v-model="datiInterni.zanzarieraTipo" :items="opzioni.zanzariereTipo"
                                    item-value="value" item-title="label" label="Zanzariera — Tipo" hide-details
                                    density="compact" variant="outlined" />
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-select v-model="datiInterni.zanzarieraColore" :items="opzioni.zanzariereColore"
                                    item-value="value" item-title="label" label="Zanzariera — Colore" hide-details
                                    density="compact" variant="outlined" />
                            </v-col>
                        </v-row>

                        <v-divider class="my-3" />

                        <!-- Cassonetto, coprifili, maniglia, vetro -->
                        <v-row dense>
                            <v-col cols="12" sm="3">
                                <v-text-field v-model="datiInterni.cassonetto" label="Cassonetto" hide-details
                                    density="compact" variant="outlined" />
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field v-model="datiInterni.ispezioneCassonetto" label="Ispezione Cassonetto"
                                    hide-details density="compact" variant="outlined" />
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field v-model="datiInterni.coprifiliInt" label="Coprifili INT" hide-details
                                    density="compact" variant="outlined" />
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field v-model="datiInterni.coprifiliEst" label="Coprifili EST" hide-details
                                    density="compact" variant="outlined" />
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-text-field v-model="datiInterni.maniglia" label="Maniglia" hide-details
                                    density="compact" variant="outlined" />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field v-model="datiInterni.vetro" label="Vetro" hide-details density="compact"
                                    variant="outlined" />
                            </v-col>
                        </v-row>
                    </v-expansion-panel-text>
                </v-expansion-panel>

                <!-- ─── SEZIONE: Opzioni Installazione ─── -->
                <v-expansion-panel eager>
                    <v-expansion-panel-title class="section-title px-3 py-2">
                        <template #default="{ isExpanded }">
                            <v-icon :class="isExpanded ? 'text-primary' : 'text-medium-emphasis'" size="18"
                                class="me-2">
                                mdi-tools
                            </v-icon>
                            <span class="text-body-2 font-weight-semibold">Opzioni Installazione - Posa</span>
                        </template>
                    </v-expansion-panel-title>

                    <v-expansion-panel-text>
                        <!-- Checkbox su più righe per leggibilità su mobile -->
                        <v-row dense class="mt-1">
                            <v-col cols="6" sm="4" md="2">
                                <v-checkbox v-model="datiInterni.smontaggio" label="Smontaggio" hide-details
                                    density="compact" color="primary" />
                            </v-col>
                            <v-col cols="6" sm="4" md="2">
                                <v-checkbox v-model="datiInterni.posaSuVecchio" label="Posa su vecchio" hide-details
                                    density="compact" color="primary" />
                            </v-col>
                            <v-col cols="6" sm="4" md="2">
                                <v-checkbox v-model="datiInterni.posaSuFalsoTelaio" label="Posa su falso telaio"
                                    hide-details density="compact" color="primary" />
                            </v-col>
                            <v-col cols="6" sm="4" md="2">
                                <v-checkbox v-model="datiInterni.posaATassello" label="Posa a tassello" hide-details
                                    density="compact" color="primary" />
                            </v-col>
                            <v-col cols="6" sm="4" md="2">
                                <v-checkbox v-model="datiInterni.noleggioCestello" label="Noleggio cestello"
                                    hide-details density="compact" color="primary" />
                            </v-col>
                            <v-col cols="6" sm="4" md="2">
                                <v-checkbox v-model="datiInterni.smaltimento" label="Smaltimento" hide-details
                                    density="compact" color="primary" />
                            </v-col>
                        </v-row>
                    </v-expansion-panel-text>
                </v-expansion-panel>

            </v-expansion-panels>

        </v-form>
    </v-card-text>
</v-card>